module.exports = __webpack_public_path__ + "static/media/OW-2021.5aeab002.jpg";